import React from 'react';
import * as moment from 'moment-timezone';
import { Calendar, Hour, Location } from './Icons';
import Tags from './Tags';
import '../i18n';
import { useTranslation } from 'react-i18next';
import { getEventNameLocale, getRegionWithException } from '../helpers'

const Card = (props) => {
    const { t, i18n } = useTranslation();
    const locale = i18n.resolvedLanguage;

    const getFormattedHour = (hourStart, hourEnd) => {
        let format = locale === 'en' ? 'hh:mm A' : 'HH:mm';
        return moment(hourStart).format(format) + ' - ' + moment(hourEnd).format(format) + ' (' + 'UTC ' + moment(hourStart).format("Z") + ')';
    }

    const getFormattedLocation = (address, city) => {
        let formattedLocation = '';

        if (address && !city) {
            formattedLocation = address;
        } else if (!address && city) {
            formattedLocation = city;
        } else {
            formattedLocation = address + ', ' + city;
        }

        return formattedLocation;
    }

    const getFormattedDay = (startDate, endDate) => {
        const startDay = startDate.locale(locale).format('DD');
        const startMonth = startDate.locale(locale).format('MMMM');
        const startYear = startDate.locale(locale).format('YYYY');

        const endDay = endDate.locale(locale).format('DD');
        const endMonth = endDate.locale(locale).format('MMMM');
        const endYear = endDate.locale(locale).format('YYYY');

        let formatEn = `${startMonth} ${startDay}`;
        let format = `${startDay} ${startMonth}`;

        if (startMonth === endMonth && startYear === endYear) {
            if (startDay === endDay) {
                return locale === 'en'
                    ? formatEn += `, ${startYear}`
                    : format += ` ${startYear}`
            } else if (endDay - startDay < 4) {
                return locale === 'en'
                    ? formatEn += `-${endDay}, ${startYear}`
                    : `${startDay}-${endDay} ${startMonth} ${startYear} `
            }
            else {
                return locale === 'en'
                    ? formatEn += `, ${startYear} ${t('to')} ${endMonth} ${endDay}, ${endYear}`
                    : format += ` ${startYear} ${t('to')} ${endDay} ${endMonth} ${endYear}`
            }
        } else {
            return locale === 'en'
                ? formatEn += `, ${startYear} ${t('to')} ${endMonth} ${endDay}, ${endYear}`
                : format += ` ${startYear} ${t('to')} ${endDay} ${endMonth} ${endYear}`
        }
    }

    const getEventImage = () => {
        const promoImgUrl = props.settings.promo_image_url || props.settings.organization_promo_image_url;

        if (props.event.website) {
            const headerBgImgUrl = props.event.website.design.header_background_image_url;
            if (headerBgImgUrl) {
                return `url(${headerBgImgUrl})`;
            }
        }

        if (promoImgUrl) {
           return `url(${promoImgUrl})`;
        } else {
           return '';
        }
    }

    return (
        <React.Fragment>
            <a href={ props.event.urls.website ?? '' } target="_blank">
                <li className="card-style relative rounded-lg bg-white">
                    <div className="card-img-bg h-44 bg-cover bg-no-repeat" style={{ backgroundImage: getEventImage() }}></div>
                    <div className="p-3">
                        <div className="flex flex-wrap">
                            {props.event.category_ids.map((categorieId) => {
                                return (
                                    <React.Fragment>
                                        <Tags categorieId={categorieId} categories={props.categories} />
                                    </React.Fragment>
                                );
                            })}
                        </div>
                        <h1 className="text-lg font-bold">{getEventNameLocale(props.event, locale)}</h1>
                        {
                            props.settings.display_date ?
                                <div className="flex text-ed-grey mb-1">
                                    <span className="mr-2 pt-0.5"><Calendar width="15px" height="15px" color="#868D96" /></span>
                                    <p style={{ fontSize: '.9rem' }}>
                                        {getFormattedDay(moment(props.event.start_date), moment(props.event.end_date))}
                                    </p>
                                </div>
                                : null
                        }
                        {
                            props.settings.display_hour ?
                                <div className="flex text-ed-grey mb-1">
                                    <span className="mr-2 pt-0.5"><Hour width="15px" height="15px" color="#868D96" className="mr-2" /></span>
                                    <div style={{ fontSize: '.9rem' }}>
                                        {getFormattedHour(props.event.start_date, props.event.end_date)}
                                    </div>
                                </div>
                                : null
                        }
                        {
                            props.settings.display_location && (props.event.venue.address || props.event.venue.city) ? <div className="flex text-ed-grey mb-1">
                                <span className="mr-2 pt-0.5"><Location width="15px" height="15px" color="#868D96" className="mr-2" /></span>
                                <div style={{ fontSize: '.9rem' }}>
                                    {getFormattedLocation(props.event.venue.address, props.event.venue.city)}
                                    <br/>
                                    {getRegionWithException(props.event.venue)}
                                </div>
                            </div> : null
                        }
                    </div>
                </li>
            </a>
        </React.Fragment >
    )
}

export default Card;